import tempMeeApi from '../../../apis/tempMee';

/**
 * auth-service's cap on `userIds` per request; past it the call is a 400
 * ("maximum 100 user IDs allowed", auth-service http/api/admin/users/users_get.go).
 * The service splits a longer list into requests of this size.
 */
export const MAX_USER_IDS_PER_REQUEST = 100;

/**
 * Fetches users by their IDs from the API
 *
 * @param {string[]} userIds - Array of user IDs to fetch
 * @returns {Promise<import('../types/User.api').IGetUsersByIdsApiResponse>} Users API response
 */
export const getUsersByIds = async (userIds) => {
  const userIdsParam = userIds.join(',');

  const response = await tempMeeApi.get('/auth-service/admin/users', {
    params: { userIds: userIdsParam },
  });

  return response.data;
};
